// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".KhOKbolJQ7vyGWiYlEFRkg\\=\\={width:100%}", "",{"version":3,"sources":["webpack://./src/components/forms/StripeForm/StripeForm.module.scss"],"names":[],"mappings":"AAEA,4BACE,UAAA","sourcesContent":["@import 'node_modules/@purple/style-library/sass/base/base';\n\n.stripe-form {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stripe-form": "KhOKbolJQ7vyGWiYlEFRkg=="
};
export default ___CSS_LOADER_EXPORT___;
